// extracted by mini-css-extract-plugin
export default {"actorsItem":"ActorCard_actorsItem__oqe55","img":"ActorCard_img__0EJYB","noImg":"ActorCard_noImg__XnJxM","name":"ActorCard_name__FaNvN","character":"ActorCard_character__7hTHq"};